
import Button from "react-bootstrap/Button";
import React from 'react';
import { Form } from 'react-bootstrap';
import './Login.css'
import { Link } from "react-router-dom";

const LogIn = () => {
    return (

        /* This is log in section */
        <div className="mx-auto w-25 my-5 py-5">
            <h2 className="text-center mt-5 ">Log In</h2>
            <Form className="py-3 mb-5">
                <Form.Group className="my-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email" />

                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Password" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" label="Remember me" />
                </Form.Group>
                <Button className="w-100" variant="primary" type="submit">
                    Submit
                </Button>
                <div className="text-center mt-4">
                    <p>Don't have an acoount <Link to='/notfound'>Sin Up</Link> </p>
                    <Link to='/notfound'>Forgot Your Password ? </Link>
                </div>
            </Form>
        </div>
    );
};

export default LogIn;